import React, { useEffect } from "react";
import Stocks from "./stocks/Stocks";
import Blog from "./blog/Blog";
import Wallet from "./wallet/Wallet";
import { useAuth } from "../../../hooks/useAuth";
import Divider from "@mui/material/Divider";
import Newsletter from "./newsletter/Newsletter";
import PostConfirmationMessage from "../post-confirmation";

export default function Main() {
  const { user } = useAuth();

  useEffect(() => {
    // Scroll to the top when the component mounts or updates
    window.scrollTo(0, 0);
  }, []);

  let content = <></>;

  if (user.status === "approved") {
    content = (
      <>
        <Stocks />
        <div className="separatorEmptyLarge secondBackground"></div>
        <Blog />
        <div className="separatorEmptyLarge secondBackground"></div>
        <Wallet />
        <div className="separatorEmptyLarge firstBackground"></div>
        <Newsletter />
        <div className="separatorEmptyLarge"></div>
      </>
    );
  } else if (user.status === "pending") {
    content = (
      <div className="secondBackground">
        <div className="maxWidth marginAuto">
          <div className="separatorEmptyLarge"></div>
          <PostConfirmationMessage userType={user.userType ?? user.usertype} />
          <div className="separatorEmptyLarge"></div>
          <Divider variant="middle" />
          <div className="separatorEmptyLarge"></div>
          <Blog />
        </div>
      </div>
    );
  }
  return <>{content}</>;
}
